import Main from '../views/main'
import CartoonList from '../views/cartoonManagement/cartoonList'
import AcgVidResCfg from '../views/cartoonManagement/acgVidResCfg'
import CartoonTagList from '../views/cartoonManagement/tagList'
import CartoonBatchUpdList from '../views/cartoonManagement/bulkUpload'
import SubsetBatchUpdList from '../views/cartoonManagement/subsetBatchUpdList'
import TagDimensionList from '../views/cartoonManagement/dimensionList'
import SectionList from '../views/cartoonManagement/dmModuleConfList'
const CartoonRouter = {
  path: '/cartoon-examine',
  component: Main,
  title: '动漫管理',
  icon: 'el-icon-video-camera-solid',
  meta: {
    keepAlive: true
  },
  children: [
    {
      path: '/cartoon-list',
      component: CartoonList,
      name: 'cartoonList',
      title: '动漫列表',
      meta: {
        title: '动漫列表',
        keepAlive: true
      }
    },
    {
      path: '/cartoon-batchUpd-list',
      component: CartoonBatchUpdList,
      name: 'cartoonBatchUpdList',
      title: '批量上传',
      meta: {
        title: '批量上传',
        keepAlive: true
      }
    },
    {
      path: '/subset-batchUpd-list',
      component: SubsetBatchUpdList,
      name: 'subsetBatchUpdList',
      title: '子媒体批量上传',
      meta: {
        title: '子媒体批量上传',
        keepAlive: true
      }
    },
    {
      path: '/cartoon-tag-list',
      component: CartoonTagList,
      name: 'cartoonTagList',
      title: '标签列表',
      meta: {
        title: '标签列表',
        keepAlive: true
      }
    },
    {
      path: '/tag-dimension-list',
      component: TagDimensionList,
      name: 'tagDimensionList',
      title: '纬度列表',
      meta: {
        title: '纬度列表',
        keepAlive: true
      }
    },
    {
      path: "/dmsection-list",
      component: SectionList,
      name: "dmSectionList",
      title: "动漫话题列表",
      meta: { title: "动漫话题列表", keepAlive: true },
    },
    {
      path: "/acg-vid-res-cfg",
      component: AcgVidResCfg,
      name: "acgVidResCfg",
      title: "Acg媒体资源库",
      meta: { title: "Acg媒体资源库", keepAlive: true },
    }
  ]
}

export default CartoonRouter
